import React from 'react';
import './PolicyPages.css';

const KvkkPage = () => {
    return (
        <div className="policy-page">
            <section className="policy-hero">
                <div className="container">
                    <h1>KVKK Aydınlatma Metni</h1>
                    <p>Kişisel verilerinizin korunmasına ilişkin haklarınız ve sorumluluklarımız</p>
                </div>
            </section>

            <div className="container main-policy-container">
                <div className="policy-content">
                    <article className="policy-article">
                        <h2>Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni</h2>
                        <p className="policy-update-date">Son Güncelleme: 18 Temmuz 2024</p>

                        <section>
                            <h3>1. Veri Sorumlusu</h3>
                            <p>
                                6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; veri sorumlusu sıfatıyla
                                [Şirket Adı] tarafından aşağıda açıklanan kapsamda işlenebilecektir.
                            </p>
                        </section>

                        <section>
                            <h3>2. Kişisel Verilerin İşlenme Amacı</h3>
                            <p>
                                Toplanan kişisel verileriniz; sunduğumuz hizmetlerden faydalanmanız, hizmetlerimizin geliştirilmesi,
                                müşteri memnuniyetinin artırılması, yasal yükümlülüklerimizin yerine getirilmesi ve sizlerle iletişim
                                kurulabilmesi amacıyla işlenmektedir.
                            </p>
                        </section>

                        <section>
                            <h3>3. İşlenen Kişisel Veriler ve Toplama Yöntemi</h3>
                            <p>
                                Kişisel verileriniz, otomatik veya otomatik olmayan yöntemlerle, şirketimizin birimleri, web sitemiz,
                                sosyal medya kanalları, mobil uygulamalar ve benzeri vasıtalarla sözlü, yazılı veya elektronik ortamda
                                toplanabilir.
                            </p>
                            <p>
                                İşlenen veri türleri arasında kimlik bilgileriniz, iletişim bilgileriniz, müşteri işlem bilgileriniz,
                                müşteri işlem güvenlik bilgileriniz, pazarlama bilgileriniz ve talep/şikayet yönetimi bilgileriniz yer
                                alabilir.
                            </p>
                        </section>

                        <section>
                            <h3>4. Kişisel Verilerin Aktarılması</h3>
                            <p>
                                Kişisel verileriniz, kanunlarda öngörülen haller dışında, yalnızca yukarıda belirtilen amaçlar doğrultusunda
                                ve bu amaçlarla sınırlı olarak, iş ortaklarımıza, tedarikçilerimize, kanunen yetkili kamu kurumlarına ve
                                özel kişilere aktarılabilecektir.
                            </p>
                        </section>

                        <section>
                            <h3>5. Veri Sahibinin Hakları</h3>
                            <p>
                                KVKK'nın 11. maddesi uyarınca veri sahipleri olarak;
                            </p>
                            <ul>
                                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
                                <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
                                <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                                <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,</li>
                                <li>Eksik veya yanlış işlenmiş olması halinde düzeltilmesini isteme,</li>
                                <li>Kanunlarda öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme,</li>
                                <li>Aktarıldığı üçüncü kişilere yukarıdaki işlemlerin bildirilmesini isteme,</li>
                                <li>Münhasıran otomatik sistemlerle analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,</li>
                                <li>Kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme haklarına sahipsiniz.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>6. İletişim Bilgileri</h3>
                            <p>
                                Yukarıda belirtilen haklarınızı kullanmak için <a href="info@fiberinternetim.com.tr">info@fiberinternetim.com.tr</a> veya <a href="destek@fiberinternetim.com.tr">destek@fiberinternetim.com.tr</a>
                                e-posta adresine veya Sarıçam/Adana adresinde bulunan merkezimize yazılı olarak başvurabilirsiniz.
                            </p>
                        </section>

                        <section>
                            <h3>7. Değişiklikler</h3>
                            <p>
                                Bu aydınlatma metni, gerekli görüldüğünde güncellenebilir. Güncel versiyon web sitemizde yayınlanacaktır.
                            </p>
                        </section>
                    </article>
                </div>
            </div>
        </div>
    );
};

export default KvkkPage;